import { yupResolver } from '@hookform/resolvers/yup'
import { memo, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ActionsDialog, InputTextField, PageError } from '../../../components'
import { useBusinessErrors } from '@src/data/selectors/app-config-selectors'
import { CreditTaskComment, creditTaskCommentSchema } from '../../../data/types'
import { reportErrorToConsole } from '../../../services/error-logger'

interface Props {
  open: boolean
  onConfirm: (comment: CreditTaskComment) => void
  onCancel: () => void
  title: string
  disableConfirm?: boolean
}

const NewTaskDialogComponent = ({ onConfirm, onCancel, open, title, disableConfirm }: Props) => {
  const { t } = useTranslation()
  const error = useBusinessErrors()

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<CreditTaskComment>({
    mode: 'onBlur',
    defaultValues: creditTaskCommentSchema.getDefault(),
    resolver: yupResolver(creditTaskCommentSchema),
  })

  useEffect(() => {
    reset(creditTaskCommentSchema.getDefault())
  }, [open, reset])

  return (
    <ActionsDialog
      onCancel={onCancel}
      onConfirm={handleSubmit(onConfirm, reportErrorToConsole)}
      open={open}
      title={title}
      disabled={disableConfirm}
    >
      <PageError errors={error} />
      <div style={{ width: 600 }}>
        <InputTextField sx={{ mt: 1 }} error={errors?.value} {...register('value')} label={t('common.comment')} />
      </div>
    </ActionsDialog>
  )
}

export default memo(NewTaskDialogComponent)
